
export default function ParentHeroSection({title, titleAdvanced, blurb}) {

    return (
        <div>
            <div
                className="paragraph paragraph--type--ixm-blocks-hero-banner paragraph--view-mode--default hero-banner hero-banner__style-2 pb-4 pb-lg-8 bg-gray-200 mb-5"
                style={{ paddingTop: "calc(80px + 2rem)" }}>
                <div className="container">
                    <nav role="navigation" aria-labelledby="system-breadcrumb" className="system-breadcrumbs mb-5">
                        <h2 id="system-breadcrumb" className="visually-hidden">Breadcrumb</h2>
                        <ul className="p-0 m-0 d-none d-lg-flex desktop-breadcrumbs">
                            <li><a href="/" className="transition__all"> <span className="material-icons">home</span>
                            </a><span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                            <li>
                                Stories<span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                            <li>
                                {title}<span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                        </ul>
                        <ul className="p-0 pt-4 m-0 d-flex d-lg-none mobile-breadcrumbs">
                            <li><a href="/" className="transition__all"> <span className="material-icons">home</span>
                            </a><span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                            <li>
                                {title}
                                <span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                        </ul>
                    </nav>
                    <div className="row justify-content-between align-items-center">
                        <div className="mh-column col-12 col-lg-6 z-1">
                            <h1 className="text-7xl d-block w-100 fw-bold mb-4">
                                <span className="d-block position-relative">
                                    {titleAdvanced}
                                </span>
                            </h1>
                            <div className="col-12 col-lg-10">
                                {blurb}
                            </div>
                            <div className=" d-none d-lg-flex mt-3 flex-wrap gap-3 "><a
                                href="/apply" target="_blank"
                                className="btn btn-lg btn-danger d-inline-flex align-items-center gap-2 font-semibold">
                                START AN APPLICATION <span className="material-symbols-outlined">arrow_forward</span>
                            </a>
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 col-lg-offset-1 mt-lg-n7 mt-3 position-relative z-0">

                            <div className="d-none d-lg-block bg-white p-2.5 shadow" style={{ maxHeight: "660px", overflow: "hidden", borderRadius: "4px" }}>
                                <video autoPlay loop muted playsInline style={{ width: "100%", height: "620px", objectFit: "cover", display: "block" }}>
                                    <source type="video/mp4"
                                            src="https://www.pexels.com/download/video/7712992/"/>
                                    Your browser does not support the video tag.
                                </video>
                            </div>


                            {/* TODO: HOST this image */}
                            <img className="img-fluid hero__image-2 d-none d-lg-block" width="70%"
                                 src="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/7713307.webp"
                                 alt="Banner Image 2"/>

                        </div>

                        <div className="col-12 d-flex d-lg-none mt-5 flex-wrap gap-3"><a
                            href="/apply" target="_blank"
                            className="btn btn-lg btn-danger d-inline-flex align-items-center gap-2 font-semibold">
                            START AN APPLICATION <span className="material-symbols-outlined">arrow_forward</span> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}